import { render, staticRenderFns } from "./manageTreatment.vue?vue&type=template&id=b13864e2&scoped=true&"
import script from "./manageTreatment.vue?vue&type=script&lang=js&"
export * from "./manageTreatment.vue?vue&type=script&lang=js&"
import style0 from "./manageTreatment.vue?vue&type=style&index=0&id=b13864e2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b13864e2",
  null
  
)

export default component.exports